const AUTO_SCROLL_TOP_BUFFER = 20;
const AUTO_SCROLL_BOTTOM_BUFFER = 50;
const AUTO_SCROLL_INTERVAL = 35;
const AUTO_SCROLL_AMOUNT = 10;

export const asSortableHelperModule = angular
  .module('Q.helpers.as-sortable-helper', [])

  .factory('asSortableHelper', function ($timeout) {
    let autoScrollTimer = null;

    function clearAutoScrollTimer() {
      if (autoScrollTimer) {
        $timeout.cancel(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    return {
      autoScroll: function (opts) {
        let oldDragMove = opts.dragMove;
        let oldDragEnd = opts.dragEnd;

        opts.dragMove = function (itemPosition, containment, event) {
          if (!event) return;

          clearAutoScrollTimer();

          let scrollContainer = containment.scrollableParent();
          let scrollContainerOffset = scrollContainer.offset();

          function autoScrollBy(amount) {
            let adjust = () =>
              scrollContainer.scrollTop(scrollContainer.scrollTop() + amount);
            adjust();
            autoScrollTimer = $timeout(
              () => autoScrollBy(amount),
              AUTO_SCROLL_INTERVAL,
              false,
            );
          }

          if (
            event.pageY <
            scrollContainerOffset.top + AUTO_SCROLL_TOP_BUFFER
          ) {
            autoScrollBy(-AUTO_SCROLL_AMOUNT);
          } else if (
            event.pageY >
            scrollContainerOffset.top +
              scrollContainerOffset.height -
              AUTO_SCROLL_BOTTOM_BUFFER
          ) {
            autoScrollBy(AUTO_SCROLL_AMOUNT);
          }

          if (oldDragMove) {
            oldDragMove.call(this, itemPosition, containment, event);
          }
        };

        opts.dragEnd = function (...args) {
          clearAutoScrollTimer();

          if (oldDragEnd) {
            oldDragEnd.apply(this, args);
          }
        };

        return opts;
      },
    };
  });
